import {EventEmitter} from "events";

import dispatcher from "../utils/dispatcher.js";
import * as Connection from "../utils/Connections";
import $ from "jquery";

class InvoiceStore extends EventEmitter {
    constructor() {
        super();
        this.profile = {};
        this.outStandingPayments = [];
        this.paidKeys = [];
        this.unpaidKeys = [];
        this.paidPayments = [];

    }

    getProfile() {
        return this.profile;
    }

    getMonth(date) {
        switch (date) {
            case "01":
                return "Jan";
                break;
            case "02":
                return "Feb";
                break;
            case "03":
                return "Mar";
                break;
            case "04":
                return "Apr";
                break;
            case "05":
                return "May";
                break;
            case "06":
                return "Jun";
                break;
            case "07":
                return "Jul";
                break;
            case "08":
                return "Aug";
                break;
            case "09":
                return "Sep";
                break;
            case "10":
                return "Oct";
                break;
            case "11":
                return "Nov";
                break;
            case "12":
                return "Dec";
                break;
        }
    }

    getPaidKeys() {
        return this.paidKeys;
    }

    getUnpaifKeys() {
        return this.unpaidKeys;
    }

    getOutStandingPayments() {
        return this.outStandingPayments;
    }

    getPaidPayments() {
        return this.paidPayments;
    }

    justEmit() {
        this.emit("change");
    }

    handleActions(action) {
        switch (action.type) {
            case "RECEIVE_MY_PROFILE": {
                this.profile = action.profile;
                Connection.getAllInvoice();
                break
            }
            case "RECEIVE_ALL_INVOICE_DETAILS": {
                this.invoices = [];
                this.paidPayments = [];
                this.outStandingPayments = [];
                this.paidKeys = [];
                this.unpaidKeys = [];
                this.paidKeysProcess = $.grep(action.invoiceKeys, function (n, i) {
                    return n.paid == "1";
                });
                this.unpaidKeysProcess = $.grep(action.invoiceKeys, function (n, i) {
                    return n.paid == "0";
                });
                // console.log(this.);
                this.invoices = action.invoiceData;
                //Running paid invoice
                var order=[];
                for (var i = 0; i < this.paidKeysProcess.length; i++) {
                    var getItem=this.paidKeysProcess[i];
                    var toprocessDate = this.paidKeysProcess[i].date_added.split("-");
                    var item =  this.getMonth( toprocessDate[1])+ "-"+ toprocessDate[0];
                    var toPlace={"data":$.grep(this.invoices, function (n, i) {
                            return n.mainKey == getItem.key;
                        }),"date":getItem.date_added};
                    if(order.hasOwnProperty(item)){
                        order[item][order[item].length] =toPlace;
                    } else {
                        this.paidKeys[this.paidKeys.length] = item;
                        order[item] = [toPlace];
                    }
                }
                this.paidPayments=order;

                //Running unpaid invoices
                var order=[];

                for (var i = 0; i < this.unpaidKeysProcess.length; i++) {
                    var getItem=this.unpaidKeysProcess[i];
                    var toprocessDate = this.unpaidKeysProcess[i].date_added.split("-");
                    var item =  this.getMonth( toprocessDate[1])+ "-"+ toprocessDate[0];
                    var toPlace={"data":$.grep(this.invoices, function (n, i) {
                        return n.mainKey == getItem.key;
                    }),"date":getItem.date_added};
                    // console.log(toPlace);
                    if(order.hasOwnProperty(item)){
                        order[item][order[item].length] =toPlace;
                    } else {
                        this.unpaidKeys[this.unpaidKeys.length] = item;
                        order[item] = [toPlace];
                    }
                }
                this.outStandingPayments=order;
                this.emit("change");
                break;
            }
        }
    }

}

const invoiceStore = new InvoiceStore;
dispatcher.register(invoiceStore.handleActions.bind(invoiceStore));

export default invoiceStore;



// WEBPACK FOOTER //
// ./src/stores/InvoiceStore.js